var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("box", { attrs: { background: "white", "no-shadow": "" } }, [
    _c(
      "div",
      { attrs: { slot: "header" }, slot: "header" },
      [
        _c("download", {
          attrs: {
            "download-formats-supported": ["json", "geojson"],
            "map-view-data": _vm.localMapViewData
          }
        }),
        _vm._v(" "),
        _c("share", { attrs: { url: _vm.shareUrl } }),
        _vm._v(" "),
        _c("print", { attrs: { "map-view-data": _vm.localMapViewData } }),
        _vm._v(" "),
        _c("h3", [_vm._v(_vm._s(_vm.$t("isochrones.isochrones")))])
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { slot: "content" }, slot: "content" },
      [
        _c("h4", [_vm._v(_vm._s(_vm.$t("isochronesDetails.reachCenters")))]),
        _vm._v(" "),
        _c(
          "v-list",
          { staticClass: "centers", attrs: { dense: "" } },
          [
            _vm._l(_vm.localMapViewData.places, function(place, index) {
              return [
                _c(
                  "v-expansion-panel",
                  {
                    key: index,
                    staticStyle: { "box-shadow": "none" },
                    attrs: { value: index === 0 ? 0 : null }
                  },
                  [
                    _c(
                      "v-expansion-panel-content",
                      { staticClass: "polygons-header" },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "header" }, slot: "header" },
                          [_c("h5", [_vm._v(_vm._s(place.placeName))])]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.localMapViewData.polygons, function(
                          polygon,
                          polygonIndex
                        ) {
                          var _obj
                          return [
                            _vm.hasAsCenter(place, polygon)
                              ? [
                                  _c(
                                    "div",
                                    {
                                      key: polygonIndex,
                                      staticStyle: { "padding-left": "10px" }
                                    },
                                    [
                                      _c(
                                        "v-layout",
                                        {
                                          staticClass: "action-options-wrapper"
                                        },
                                        [
                                          _c(
                                            "v-flex",
                                            _vm._b(
                                              {},
                                              "v-flex",
                                              ((_obj = {}),
                                              (_obj[
                                                _vm.$highResolution
                                                  ? "lg4"
                                                  : "md12"
                                              ] = true),
                                              _obj),
                                              false
                                            ),
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass: "no-margin",
                                                  attrs: {
                                                    icon: "",
                                                    title: _vm.$t(
                                                      "isochronesDetails.toggleVisibility"
                                                    )
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.toggleVisibility(
                                                        polygonIndex
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        color: polygon
                                                          .properties.visible
                                                          ? "primary"
                                                          : "dark"
                                                      }
                                                    },
                                                    [_vm._v("visibility")]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "polygon-area",
                                                  style: {
                                                    background:
                                                      polygon.properties.color
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "b",
                                                    {
                                                      staticStyle: {
                                                        "font-size": "11px"
                                                      },
                                                      style: {
                                                        color: _vm.polygonAreaTextColor(
                                                          polygon.properties
                                                            .color
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          polygon.properties.label.replace(
                                                            "Polygon",
                                                            ""
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            { attrs: { lg3: "" } },
                                            [
                                              polygon.properties.total_pop !==
                                              null
                                                ? [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          "font-size": "12px"
                                                        }
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "global.population"
                                                              )
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              polygon.properties
                                                                .total_pop
                                                            )
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  ]
                                                : _vm._e()
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c("v-spacer"),
                                          _vm._v(" "),
                                          _vm.$highResolution
                                            ? _c(
                                                "v-flex",
                                                { attrs: { md5: "" } },
                                                [
                                                  _c("v-slider", {
                                                    staticClass:
                                                      "polygon-opacity-slider",
                                                    attrs: {
                                                      min: 0,
                                                      max: 1,
                                                      "prepend-icon": "opacity",
                                                      "thumb-size": 24,
                                                      "thumb-label": "always",
                                                      label: "",
                                                      title: _vm.$t(
                                                        "isochronesDetails.opacity"
                                                      ),
                                                      step: 0.1
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        return _vm.polygonOpacityChanged(
                                                          polygonIndex
                                                        )
                                                      }
                                                    },
                                                    model: {
                                                      value:
                                                        polygon.properties
                                                          .fillOpacity,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          polygon.properties,
                                                          "fillOpacity",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "polygon.properties.fillOpacity"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("br")
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              : _vm._e()
                          ]
                        }),
                        _vm._v(" "),
                        _c("br")
                      ],
                      2
                    )
                  ],
                  1
                )
              ]
            })
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c80142b", { render: render, staticRenderFns: staticRenderFns })
  }
}